import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WoRecurringSchedule} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-pm-schedule-list',
  templateUrl: './pm-schedule-list.component.html',
  standalone: false,
})
export class PmScheduleListComponent implements OnInit {

  schedules: WoRecurringSchedule[] = [];
  isLoaded = false;

  constructor(
    private router: Router,
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.woService.getPmSchedules().subscribe({
      next: (res) => {
        this.schedules = res;
        this.isLoaded = true;
      },
      error: () => {
        this.notification.showErrorToast('Error loading PM schedules.');
        this.isLoaded = true;
      }
    });
  }

  edit(id: string): void {
    this.router.navigate(['/work-orders/pm-schedules/pm-schedule-form'], {queryParams: {id}});
  }

  newSchedule(): void {
    this.router.navigate(['/work-orders/pm-schedules/pm-schedule-form']);
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(
      ['Delete this PM schedule?'],
      () => {
        this.woService.deletePmSchedule(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Schedule deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting schedule.');
          }
        });
      },
      () => {
      }
    );
  }

  generate(id: string): void {
    this.confirmDialog.confirmThis(
      ['Generate a new work order from this schedule now?'],
      () => {
        this.woService.generateFromSchedule(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Work order generated.');
          },
          error: () => {
            this.notification.showErrorToast('Error generating work order.');
          }
        });
      },
      () => {
      }
    );
  }

  isOverdue(date: string): boolean {
    return new Date(date) < new Date();
  }

  frequencyLabel(s: WoRecurringSchedule): string {
    return `Every ${s.frequency_interval > 1 ? s.frequency_interval + ' ' : ''}${s.frequency}`;
  }
}
